/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains description of current page/template
 */
export const descriptionContextKey = "description";
